const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPerson(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "person"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3344_55517",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9",
    style: {
      fill: "#D9D9D9",
      fill: "color(display-p3 0.8510 0.8510 0.8510)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3344_55517)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "person_2",
    d: "M12.0001 12C10.9001 12 9.95846 11.6083 9.17512 10.825C8.39179 10.0417 8.00012 9.1 8.00012 8C8.00012 6.9 8.39179 5.95833 9.17512 5.175C9.95846 4.39167 10.9001 4 12.0001 4C13.1001 4 14.0418 4.39167 14.8251 5.175C15.6085 5.95833 16.0001 6.9 16.0001 8C16.0001 9.1 15.6085 10.0417 14.8251 10.825C14.0418 11.6083 13.1001 12 12.0001 12ZM4.00012 18V17.2C4.00012 16.6333 4.14596 16.1125 4.43762 15.6375C4.72929 15.1625 5.11679 14.8 5.60012 14.55C6.63346 14.0333 7.68346 13.6458 8.75012 13.3875C9.81679 13.1292 10.9001 13 12.0001 13C13.1001 13 14.1835 13.1292 15.2501 13.3875C16.3168 13.6458 17.3668 14.0333 18.4001 14.55C18.8835 14.8 19.271 15.1625 19.5626 15.6375C19.8543 16.1125 20.0001 16.6333 20.0001 17.2V18C20.0001 18.55 19.8043 19.0208 19.4126 19.4125C19.021 19.8042 18.5501 20 18.0001 20H6.00012C5.45012 20 4.97929 19.8042 4.58762 19.4125C4.19596 19.0208 4.00012 18.55 4.00012 18ZM6.00012 18H18.0001V17.2C18.0001 17.0167 17.9543 16.85 17.8626 16.7C17.771 16.55 17.6501 16.4333 17.5001 16.35C16.6001 15.9 15.6918 15.5625 14.7751 15.3375C13.8585 15.1125 12.9335 15 12.0001 15C11.0668 15 10.1418 15.1125 9.22512 15.3375C8.30846 15.5625 7.40012 15.9 6.50012 16.35C6.35012 16.4333 6.22929 16.55 6.13762 16.7C6.04596 16.85 6.00012 17.0167 6.00012 17.2V18ZM12.0001 10C12.5501 10 13.021 9.80417 13.4126 9.4125C13.8043 9.02083 14.0001 8.55 14.0001 8C14.0001 7.45 13.8043 6.97917 13.4126 6.5875C13.021 6.19583 12.5501 6 12.0001 6C11.4501 6 10.9793 6.19583 10.5876 6.5875C10.196 6.97917 10.0001 7.45 10.0001 8C10.0001 8.55 10.196 9.02083 10.5876 9.4125C10.9793 9.80417 11.4501 10 12.0001 10Z",
    fill: "#1859FF",
    style: {
      fill: "#1859FF",
      fill: "color(display-p3 0.0941 0.3490 1.0000)",
      fillOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPerson);
export default __webpack_public_path__ + "static/media/icon_person.ac6a2388f65d7f5b6e1e220eba9c1cc3.svg";
export { ForwardRef as ReactComponent };